function get_option(val){
    if(val == 1){
        var optionsData = [
            { value: 1, text: "Less than 1200cc" },
            { value: 2, text: "1200cc - 1500cc" },
            { value: 3, text: "1500cc - 1799cc" },
            { value: 4, text: "1799cc - 3000cc" },
            { value: 5, text: "more than 3000cc" }
        ];
    } else if(val == 2 || val == 3){
        var optionsData = [
            { value: 1, text: "Less than 1500cc" },
            { value: 2, text: "1500cc - 1799cc" },
            { value: 3, text: "1799cc - 2500cc" },
            { value: 4, text: "2500cc - 3000cc" },
            { value: 5, text: "more than 3000cc" }
        ];
    } else {
        var optionsData = [
            { value: 1, text: "Less than 1500cc" },
        ];
    }
    return optionsData;
}

$(document).ready(function() {
    $('#type').change(function(){
        let val = $(this).val();
        if(val){
            $('#engine').find('option:not(:first)').remove();
            var op = get_option(val);

            $.each(op, function(index, item) {
                $('#engine').append($('<option>', {
                    value: item.value,
                    text: item.text
                }));
            });
        }
    });

    var selectedValue = $("#type option:selected").val();

    if(selectedValue){
        console.log(selectedValue);
        var op = get_option(selectedValue);

        const urlParams = new URLSearchParams(window.location.search);
        const parameterValue = urlParams.get('engine');

        $.each(op, function(index, item) {
            $('#engine').append($('<option>', {
                value: item.value,
                text: item.text
            }));
        });

        $('#engine').val(parameterValue);
    }
});
